/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.payroll.paytypes.allowance
 * @name TimePayrollAllowanceListCtrl
 */
angular.module('mercury.modules.time.payroll.paytypes.allowance')
.controller('TimePayrollAllowanceListCtrl', ["dialog", "$q", "$scope", "TimePayrollAllowance", "TimeRoles", "TimeStaff", "title", function(dialog, $q, $scope, TimePayrollAllowance, TimeRoles, TimeStaff, title) {
  title.set('Allowances & Deductions');

  $scope.loading = $q.all({
    allowances: TimePayrollAllowance.getAll(),
    staff: TimeStaff.getAllActive(),
    roles: TimeRoles.getAllActive()
  });

  $scope.loading.then(function(result) {
    $scope.paytypes = result.allowances;
    $scope.staff = result.staff;
    $scope.roles = result.roles;
  });

  $scope.quantityTypesMap = {
    0: 'Fixed Rate',
    1: 'Hours Worked',
    2: 'Staff Orders',
    3: 'Staff Sales'
  };

  $scope.edit = function(paytype) {
    $scope.selectedPaytype = angular.copy(paytype);
    dialog.open({
      templateUrl: 'modules/time/payroll/paytypes/allowance/edit.tpl.html',
      controller: 'TimePayrollAllowanceEditCtrl',
      scope: $scope
    })
    .then(function(updatedPaytype) {
      angular.forEach($scope.paytypes, function(paytype, index) {
        if (paytype.id == updatedPaytype.id) {
          if (updatedPaytype.datestampDeleted) {
            $scope.paytypes.splice(index, 1);
          } else {
            $scope.paytypes.splice(index, 1, updatedPaytype);
          }
        }
      });
    });
  };

  $scope.addNew = function() {
    $scope.selectedPaytype = null;
    dialog.open({
      templateUrl: 'modules/time/payroll/paytypes/allowance/edit.tpl.html',
      controller: 'TimePayrollAllowanceEditCtrl',
      scope: $scope
    })
    .then(function(newAllowance) {
      $scope.paytypes.push(newAllowance);
    });
  };
}]);
